// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__gpo1a","content":"styles_content__2CKbp","checkbox":"styles_checkbox__10mnS","checkboxLabel":"styles_checkboxLabel__2TGmo"};